import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { PageNotFoundComponent } from './page-not-found.component'
import {
  ConfigModule,
  CmsConfig,
  provideDefaultConfig,
  I18nModule,
} from '@spartacus/core'
import { NgSelectModule } from '@ng-select/ng-select'
import { environment } from '../../../environments/environment'

@NgModule({
  declarations: [PageNotFoundComponent],
  imports: [
    CommonModule,
    I18nModule,
    NgSelectModule,
    ConfigModule.withConfig({
      cmsComponents: {
        VSPageNotFoundComponent: {
          component: PageNotFoundComponent,
        },
      },
      i18n: {
        backend: {
          loadPath:
            environment.deployPath + '/assets/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: {
          common: ['pagenot'],
        },
      },
    } as CmsConfig),
  ],
  exports: [PageNotFoundComponent],
})
export class PageNotFoundModule {}
